var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneTrainLastBracket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 75,
    viewBox: "0 0 26 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 69.5C24.3807 69.5 25.5 70.6193 25.5 72C25.5 73.3807 24.3807 74.5 23 74.5V69.5ZM5.5 0V54H0.5V0H5.5ZM5.5 54C5.5 58.965 5.93164 62.9982 7.1559 65.7265C7.74523 67.0399 8.47217 67.9427 9.33097 68.5287C10.1775 69.1063 11.3326 69.5 13 69.5V74.5C10.5007 74.5 8.32252 73.8937 6.51278 72.6588C4.71534 71.4323 3.46311 69.7101 2.5941 67.7735C0.901696 64.0018 0.5 59.035 0.5 54H5.5ZM13 69.5H23V74.5H13V69.5Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTrainLastBracket);
export default __webpack_public_path__ + "static/media/one_train_last_bracket.ca5f7aa3dfd3cb4a430866cb76ce4e0b.svg";
export { ForwardRef as ReactComponent };